<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">{{ page.desc }}</p>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <!-- 系统信息 -->
        <block-cntr
          :btitle="page.blkTitle.system"
          style="height: 100%"
          :closeButton="false"
        >
          <!-- 刷新按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div @click="loadsys" class="btn" style="padding: 0px">
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <form class="form-horizontal">
            <div class="form-group" v-for="(value, key) in system" :key="key">
              <div class="col-lg-4">
                <label>{{ value.k }}</label>
              </div>
              <div class="col-lg-8">
                <label>{{ value.v }}</label>
              </div>
            </div>
          </form>
        </block-cntr>
      </div>
      <div class="col-lg-6">
        <!-- 版本信息 -->
        <block-cntr
          :btitle="page.blkTitle.version"
          style="height: 100%"
          :closeButton="false"
        >
          <form class="form-horizontal">
            <div class="form-group" v-for="(value, key) in version" :key="key">
              <div class="col-lg-4">
                <label>{{ value.k }}</label>
              </div>
              <div class="col-lg-8">
                <label>{{ value.v }}</label>
              </div>
            </div>
          </form>
        </block-cntr>
      </div>
    </div>
  <!--
    <div class="row">
      <div class="col-lg-6">
         CPU及内存信息 
        <block-cntr
          :btitle="page.blkTitle.cpu_memory"
          style="height: 100%"
          :closeButton="false"
        >
           刷新按钮 
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div @click="loadcpu" class="btn" style="padding: 0px">
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <form class="form-horizontal">
            <div
              class="form-group"
              v-for="(value, key) in cpu_memory"
              :key="key"
            >
              <div class="col-lg-4">
                <label>{{ value.k }}</label>
              </div>
              <div class="col-lg-8">
                <label>{{ value.v }}</label>
              </div>
            </div>
          </form>
        </block-cntr>
      </div>
    </div>
    -->
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "@/lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "deviceStatus",
  components: {
    BlockCntr,
  },
  data() {
    return {
      page: en.page.devstatus,
      system: "",
      version: "",
      cpu_memory: "",
    }
  },
  created() {
    this.loadsys()
    this.loadver()
    this.loadcpu()
  },
  methods: {
    loadsys() {
      get("system")
        .then((res) => (this.system = res.data))
        .catch((err) => {
          this.system = en.system
        })
    },
    loadver() {
      get("version")
        .then((res) => (this.version = res.data))
        .catch((err) => {
          this.version = en.version
        })
    },
    loadcpu() {
      get("cpumem")
        .then((res) => (this.cpu_memory = res.data))
        .catch((err) => {
          this.cpu_memory = en.cpu_memory
        })
    },
  },
}
</script>

 <style lang="less" scoped>
</style>